import { GET_AGENT_MANAGER_RESULTS_BY_ID_QUERY } from '@/graphql/agent.gql';
import { AgentResult } from '@/types/agent.type';
import { useQuery } from '@apollo/client';
import { LoadingSpinBlackCustom } from '../utils/loading.component';

interface Props {
  agentManagerId: string;
  agentId: string;
}

export function AgentResultsComponent({
  agentManagerId,
  agentId,
  ...props
}: Props) {
  // Variables

  // GraphQL
  const { loading, error, data } = useQuery(
    GET_AGENT_MANAGER_RESULTS_BY_ID_QUERY,
    {
      variables: { agentManagerId: agentManagerId },
      fetchPolicy: 'network-only'
    }
  );

    // Show loading
    if (loading) {
      return (
      <>
        <div className="bg-gray-50 p-2 w-full h-full rounded-lg flex justify-center items-center">
        <LoadingSpinBlackCustom className="w-5 h-5"></LoadingSpinBlackCustom>
        </div>
      </>
      );
    }

  if (
    !data ||
    !data.agent_managers ||
    data.agent_managers.length == 0 ||
    !data.agent_managers[0].agents ||
    data.agent_managers[0].agents.length == 0
  ) {
    return <></>;
  }

  let agentResults: AgentResult[] = [];
  if (
    data.agent_managers[0].agents &&
    data.agent_managers[0].agents.length > 0
  ) {
    data.agent_managers[0].agents.forEach(
      (agent: { agent_results: AgentResult[] }) => {
        agentResults = [...agentResults, ...agent.agent_results];
      }
    );
  }

  return (
    <div className="py-4 flex flex-col gap-6">
      {agentResults &&
        agentResults.map((agentResult, index) => (
          <div className="flex flex-col gap-3" key={index}>
            <div className="p-2 rounded-md bg-[#f3f3f3] leading-relaxed">
              <span className="font-bold">Thoughts:</span>{' '}
              {agentResult?.thoughts ||
                (agentResult?.is_final_answer && 'Preparing a final answer')}
            </div>

            <div className="flex flex-col p-2 rounded-md divide-y divide-gray-300 bg-[#f3f3f3]">
              <div className="pb-3 whitespace-pre-line leading-relaxed">
                <span className="font-bold text-green-500">Completing:</span>{' '}
                {agentResult?.action_input ||
                  (agentResult?.is_final_answer && 'Final answer is ready.')}
              </div>

              <div
                className="pt-3 whitespace-pre-line leading-relaxed"
                dangerouslySetInnerHTML={{ __html: agentResult?.results || '' }}
              ></div>
            </div>
          </div>
        ))}
    </div>
  );
}
